import React from 'react'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'
import SubnavBar from 'Components/Shared/SubnavBar'

type Props = {
  name: string
  preview?: string
  onClose?: (page: string) => void
}

const Breadcrumbs: React.ComponentType<Props> = props => {
  const { name, onClose = () => {}, preview = '' } = props
  const breadcrumbs: BreadcrumbLink[] = [
    {
      url: '/report/constructroad',
      title: 'Home',
      icon: '/home.png',
      active: true,
      showTitle: false,
    },
    {
      url: '/report/constructroad',
      title: 'รายงานถนน',
      active: true,
      showTitle: true,
    },
  ]

  breadcrumbs.push({
    url: '',
    title: 'ระหว่างก่อสร้างถนน',
    active: name ? true : false,
    showTitle: name ? true : false,
    onClick: () => onClose(''),
  })

  if (name) {
    breadcrumbs.push({
      url: '',
      title: name,
      active: preview ? true : false,
      showTitle: preview ? true : false,
      onClick: () => onClose('detail'),
    })
  }

  if (preview) {
    breadcrumbs.push({
      url: '',
      title: preview,
      active: false,
      showTitle: false,
    })
  }

  return <SubnavBar breadcrumbs={breadcrumbs} hideSearch={true} />
}

export default Breadcrumbs
